import _typeof from '@babel/runtime/helpers/typeof';
import { defaultTheme } from './Theme.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var _recurseAndFill = function recurseAndFill(obj, fill) {
  for (var key in fill) {
    var value = obj[key];
    var fillValue = fill[key];
    if (value === undefined) {
      obj[key] = fill[key];
      if (_typeof(fillValue) === 'object') {
        _recurseAndFill(obj[key], fill[key]);
      }
    } else if (value && _typeof(value) === 'object') {
      _recurseAndFill(value, fillValue);
    }
  }
};
var createTheme = function createTheme(inputTheme) {
  var baseTheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTheme;
  var theme = JSON.parse(JSON.stringify(inputTheme));
  theme.variant = theme.variant || 'normal';
  _recurseAndFill(theme, baseTheme);
  return theme;
};

export { createTheme };
